/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScannerViolationComments {
    getFixupPrototypeFunction() { return ScannerViolationComments.fixupPrototype; }

    static newInstance(model: Partial<ScannerViolationComments>): ScannerViolationComments {
        let obj = Object.assign(new ScannerViolationComments(), model);
        ScannerViolationComments.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScannerViolationComments>): ScannerViolationComments {
        if (!model) return null;
        return ScannerViolationComments.newInstance(<ScannerViolationComments> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScannerViolationComments) {
        if (!obj) return;

        models.ScannerViolationComments.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScannerViolationComments): boolean {
        Object.setPrototypeOf(obj, ScannerViolationComments.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.touched_at === "string") {
            this.touched_at = new Date(<string><any>this.touched_at);
        }
        if (this.governance_findings) {
            for (let val of this.governance_findings) {
                models.FileWiseViolations.fixupPrototype(val);
            }
        }
        if (this.cost_findings) {
            for (let val of this.cost_findings) {
                models.IndividualCostOutput.fixupPrototype(val);
            }
        }
        if (this.notification_details) {
            for (let val of this.notification_details) {
                models.StepWiseNotifications.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique Identifier of the Pull Request which is auto generated.
     */
    pr_sys_id: string;

    /**
     * This Field will contain fields such as terraform state whenever provisioning happens for a  pull request.
     */
    provision_details: string;

    governance_findings: Array<models.FileWiseViolations>;

    cost_findings: Array<models.IndividualCostOutput>;

    /**
     * ShA Id of the commit which was committed.
     */
    commit_id: string;

    /**
     * name of the directory against which the violation has been generated.
     */
    directory_name: string;

    /**
     * name of the classification
     */
    classification: string;

    /**
     * Date time at which the sync recently happened for a commit.
     */
    touched_at: Date;

    notification_details: Array<models.StepWiseNotifications>;

}
